import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { initFlowbite } from 'flowbite';
import { NotificationComponent } from './shared/components/notification/notification.component';
import { GlobalLoaderComponent } from './core/loading/global-loader.component';

@Component({
  selector: 'app-root',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    RouterOutlet,
    NotificationComponent,
    GlobalLoaderComponent,
  ],
  template: `
    <router-outlet></router-outlet>
    <app-notification></app-notification>
    <app-global-loader></app-global-loader>
  `,
})
export class AppComponent {
  constructor() {
    initFlowbite();
  }
}
